/* eslint-disable no-underscore-dangle */
import { Grid, MenuItem, MenuList, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { useUser } from 'src/hooks/useUser';
import { notificationState } from 'src/stores/state';

import { filterNotifications } from './notification-helpers';
import NotificationItem from './NotificationItem';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    width: 300,
    maxHeight: 400,
    overflowY: 'auto',
  },
  typography: {
    fontWeight: 'bold',
  },
  list: {
    marginBottom: theme.spacing(1),
  },
  menuItemFallback: {
    // not clickable
    pointerEvents: 'none',
    backgroundColor: theme.palette.background.paper,
  },
}));

type NotificationPopupProps = {
  onlyUnread?: boolean;
  showUnread?: Dispatch<SetStateAction<boolean>>;
  login: boolean;
};

const NotificationPopup = ({ onlyUnread, showUnread, login }: NotificationPopupProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: user } = useUser();

  const [notifications, setNotifications] = useRecoilState(notificationState);

  return (
    <Paper className={classes.paper}>
      <Typography className={classes.typography} variant="subtitle1">
        {onlyUnread ? t('notificationBanner.unreadMessages') : t('notificationBanner.allMessages')}
      </Typography>
      <MenuList>
        {(notifications ?? []).length > 0 ? (
          notifications.map((n) => (
            <NotificationItem
              login={login}
              key={n._id}
              message={n}
              refetch={() => setNotifications(filterNotifications(notifications, user, onlyUnread ?? true))}
            />
          ))
        ) : (
          <MenuItem className={classes.menuItemFallback} disabled>
            {t('notificationBanner.noUnreadMsg')}
          </MenuItem>
        )}
      </MenuList>
      <hr />
      <Grid container justifyContent="center">
        <MenuItem
          className={classes.list}
          onClick={() => {
            if (showUnread) showUnread(!(onlyUnread ?? true));
          }}
        >
          {onlyUnread ? t('notificationBanner.displayAll') : t('notificationBanner.unreadMessages')}
        </MenuItem>
      </Grid>
    </Paper>
  );
};

export default NotificationPopup;
